
import gql from "graphql-tag";

export const ADD_PASSENGERS = gql`
   mutation addPassengers($bookingId:String!, $pax:Int!, $lead:JSON){
      addPassengers(bookingId:$bookingId, pax:$pax, lead:$lead)
   }
`;

export const UPDATE_PASSENGERS = gql`
   mutation updatePassenger($tmsBookingId:String!, $passengerId:String!, $data:JSON!){
      updatePassenger(tmsBookingId:$tmsBookingId, passengerId:$passengerId, data:$data)
   }
`;